// --------------------------------------------------------
// DROPDOWN CUSTOM - CustomDropdown
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import {
  CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import Colors from "../../constants/Colors";
import { ReactComponent as Check } from "../../assets/imgs/check.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../..";
import Company from "../../models/core/company/Company";
import * as relationShip from "../../store/actions/relationshipGhe";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// DROPDOWN CUSTOM INTERFACE
// --------------------------------------------------------

interface ICustomDropdown {
  disabled: boolean;
  backgroundColor?: string;
  placeholder?: string;
  textColor?: string;
  containerStyle?: any;
  style?: any;
  error?: any;
  idSaude: string;
  multiple: boolean;
  id: string;
  arraySaude: any[];
  value: any;
  attRelationShip: any;
}

/**
/**
 * A component that renders a Custom Dropdown.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const GheDropdown = ({
  placeholder = "",
  error = "",
  disabled,
  backgroundColor = Colors.lightBlue,
  textColor = Colors.SPM800,
  style = {},
  multiple,
  id,
  value,
  idSaude,
  containerStyle = {},
  arraySaude = [],
  attRelationShip
}: ICustomDropdown) => {
  // --------------------------------------------------------
  // DROPDOWN CUSTOM PRIVATE DECLARATIONS
  // --------------------------------------------------------

  const [isOpen, setIsOpen] = useState(false);
  const [name, setNameGhe] = useState({});
  const [isLoading, setLoading] = useState(false);

  const hasValue = value?.id !== ''

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const dispatch = useAppDispatch();

  const arrayOneRelationShip: any[] = useSelector(
    (state: any) => state.relationShip.arrayOneRelationShip
  );

  const currentCompany: Company = useSelector(
    (state: any) => state.login.currentCompany
  );

  // Atualizar um GHE relacionado ao posto de trabalho
  async function fetchInfomationForAtualization(idSaude: any) {
    const idEmpresa = currentCompany.id;
    const idPosto = id;
    const response: any = arrayOneRelationShip.filter((r: any) =>
      r.postoTrabalhoId === idPosto ? -1 : 0
    );

    const idRelation = response[0].id ?? null;

    await dispatch(
      relationShip.updateRelationShip(
        idEmpresa,
        idRelation,
        idPosto,
        idSaude.id
      )
    );
    attRelationShip()
  }

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      {isLoading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      ) : (
        <FormControl style={{ ...containerStyle }}>
          {arraySaude !== null && (
            <InputLabel style={{ color: "#07365F66" }}>
              {placeholder}
            </InputLabel>
          )}
          <Select
            size="medium"
            native={false}
            disabled={disabled}
            multiple={multiple}
            open={isOpen}
            IconComponent={() => (
              <KeyboardArrowDownIcon
                onClick={() => {
                  setIsOpen(true);
                }}
                style={{ cursor: "pointer", marginRight: 1 }}
              />
            )}
            label={arraySaude.length === 0 ? placeholder : ""}
            onOpen={handleOpen}
            onClose={handleClose}
            value={value}
            style={{
              backgroundColor: hasValue ? "#f3faff" : "#EF4444",
              borderRadius: 8,
              color:  hasValue ? "#07365F" : "white",
              ...style,
            }}
            onChange={(event) => {
              fetchInfomationForAtualization(event.target.value);
            }}
            renderValue={(selected: any) => selected.nome}
          >
            {arraySaude.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  value={item}
                  onClick={() => ""}
                  dense
                  style={{
                    height: 15,
                    color: Colors.SPM800,
                  }}
                >
                  <ListItemText
                    primary={item.nome}
                    style={{ color: Colors.SPM800 }}
                  />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </>
  );
  // --------------------------------------------------------
};

export default GheDropdown;
